import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed top-5 right-5 z-50 w-80" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastStore.toasts, (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toast.id,
            class: _normalizeClass([
          'alert py-3 px-4 mb-3 rounded-md flex items-center justify-between shadow-md',
          {
            'text-success-500 bg-success-50 border border-success-200': toast.type === 'success',
            'text-danger-500 bg-danger-50 border border-danger-200': toast.type === 'error',
            'text-warning-500 bg-warning-50 border border-warning-200': toast.type === 'warning',
            'text-info-500 bg-info-50 border border-info-200': toast.type === 'info'
          }
        ])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("i", {
                class: _normalizeClass([
              'mr-2 text-lg',
              {
                'ri-checkbox-circle-line': toast.type === 'success',
                'ri-error-warning-line': toast.type === 'error',
                'ri-alert-line': toast.type === 'warning',
                'ri-information-line': toast.type === 'info'
              }
            ])
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(toast.message), 1)
            ]),
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.toastStore.remove(toast.id)),
              class: "leading-none text-[20px] close-btn"
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "ri-close-line" }, null, -1)
            ]), 8, _hoisted_3)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}